import { render, staticRenderFns } from "./MyPendingNotifications.vue?vue&type=template&id=6c7108c8"
import script from "./MyPendingNotifications.vue?vue&type=script&lang=js"
export * from "./MyPendingNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports